import React from 'react';
import { Box, Grid, Link, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { LocationOn as LocationIcon } from '@mui/icons-material';
import { apiGetRegionList } from '@/modules/regions/services/regions.service';
import { useTranslation } from 'react-i18next';

export function CityLinksSection() {
    const {data: regions} = apiGetRegionList({
        limit: 100,
        offset: 0
    });

    const {i18n} = useTranslation();

    return (
        <Paper
            elevation={1}
            sx={{
                p: 3,
                mb: 4,
                borderRadius: 2,
                bgcolor: '#f8f9fa',
                border: '1px solid #e9ecef'
            }}
        >
            <Box sx={{mb: 3}}>
                <Typography
                    variant="h6"
                    component="h2"
                    sx={{
                        color: '#2c3e50',
                        fontWeight: 'bold',
                        mb: 1,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}
                >
                    <LocationIcon sx={{color: '#007bff'}}/>
                    Автошколы по городам Казахстана
                </Typography>
                <Typography
                    variant="body2"
                    sx={{color: '#6c757d'}}
                >
                    Выберите ваш город для просмотра автошкол в вашем регионе
                </Typography>
            </Box>

            <Grid
                container
                spacing={1}
            >
                {regions?.items.map((city) => (
                    <Grid
                        item
                        xs={6}
                        sm={4}
                        md={3}
                        lg={2}
                        key={city.id}
                    >
                        <Link
                            component={RouterLink}
                            to={`/catalog/${city.id}`}
                            sx={{
                                display: 'block',
                                p: 1.5,
                                textDecoration: 'none',
                                color: '#495057',
                                backgroundColor: 'white',
                                borderRadius: 1,
                                border: '1px solid #dee2e6',
                                transition: 'all 0.2s ease',
                                fontSize: '0.875rem',
                                textAlign: 'center',
                                '&:hover': {
                                    color: '#007bff',
                                    borderColor: '#007bff',
                                    backgroundColor: '#f8f9fa',
                                    transform: 'translateY(-1px)',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }
                            }}
                        >
                            {i18n.language === 'kz' ? city.name_kz : city.name_ru}
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    );
}
